import React from 'react'
import ReactDOM from 'react-dom'
import cn from 'classnames'

import * as s from './ModalCookieConsent.module.scss'
import Typography from '../Typography'
import { Button } from '../Button'
import Link from '../Link'

interface ModalCookieConsentProps {
  onAccept: () => void
  consentText: string
  buttonText: string
  linkText: string
  linkTo: string
  className?: string
  contentClassName?: string
}

const ModalCookieConsent: React.FC<ModalCookieConsentProps> = ({
  onAccept,
  className,
  consentText,
  buttonText,
  linkText,
  linkTo,
  contentClassName,
}) => {
  return ReactDOM.createPortal(
    <div className={cn(s.modal, className)}>
      <div className={cn(s.modal_content, contentClassName)}>
        <div className="w-100 h-100">
          <Typography variant="body1" size={18}>
            {consentText}{' '}
            <Link
              href={linkTo}
              rel="nofollow noreferrer"
              target="_blank"
              style={{ textDecorationLine: 'underline' }}
            >
              {linkText}
            </Link>
          </Typography>
          <Button className="mt-4" isFullWidth onClick={onAccept}>
            {buttonText}
          </Button>
        </div>
      </div>
    </div>,
    document.body
  )
}

export default ModalCookieConsent
